import styled from "styled-components";

export const HiddenInput = styled.input`
    all: unset;
    height: 20px;
    font-size: 14px;
    padding: 0 2px 0 10px;
    width: ${(props) => {
        const charsNumber = props.value.length;
        return charsNumber ? `calc(${charsNumber}ch + 2px)` : "10px";
    }};
`;
